<div class="item-container">
  <div class="item-header">
    <h5 class="text-center">View Request</h5>
    <div class="edit-icons" mat-dialog-close>
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content d-flex flex-column">
    <div class="header d-flex flex-wrap gap-2">
      <div class="d-flex me-auto flex-wrap me-2 gap-2">
        <mat-select [value]="'History'" class="form-control s-1 cal-view">
          <mat-option value="History">History</mat-option>
          <mat-option value="2013">2013</mat-option>
          <mat-option value="2014">2014</mat-option>
          <mat-option value="2015">2015</mat-option>
        </mat-select>

        <div class="d-flex gap-2 date-container">
          <!-- <div class="d-flex align-items-center">From:</div> -->
          <ng-container>
            <div class="in-box w-200 start-date">
              <input class="form-control ps-5 h-100" [matDatepicker]="sdDate" placeholder="Start Date" />
              <mat-datepicker-toggle matIconSuffix [for]="sdDate"></mat-datepicker-toggle>
              <mat-datepicker #sdDate></mat-datepicker>
            </div>
          </ng-container>
          <!-- <div class="d-flex align-items-center">To:</div> -->
          <ng-container>
            <div class="in-box w-200 end-date">
              <input class="form-control ps-5 h-100" [matDatepicker]="stDate" placeholder="End Date" />
              <mat-datepicker-toggle matIconSuffix [for]="stDate"></mat-datepicker-toggle>
              <mat-datepicker #stDate></mat-datepicker>
            </div>
          </ng-container>
        </div>

      </div>
      <div class="d-flex flex-wrap gap-2">
        <div class="search-cont ">
          <div class="s-in form-input" style="position:relative">
            <mat-icon class="input-icon">search</mat-icon>
            <input type="text" placeholder="Search" class="form-control" />
          </div>
        </div>
        <div class="search-cont">
          <div class="s-item d-box ">
            <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>